(function(){
if(window.__smCardTouch)return;window.__smCardTouch=true;
var mq=window.matchMedia&&window.matchMedia('(hover:none)');
if(!mq||!mq.matches)return;
function main(c){return c.querySelector('.sm-card__img img:not(.sm-card__img2)');}
function prep(c){
 if(c.__smReady)return;c.__smReady=true;
 var m=main(c),s=c.querySelector('.sm-card__img2');
 if(m&&s){var cs=getComputedStyle(m);s.style.objectPosition=cs.objectPosition;s.style.objectFit=cs.objectFit;}
 c.querySelectorAll('.sm-sw i[data-img]').forEach(function(i){var im=new Image();im.src=i.getAttribute('data-img');});
}
var tm=0,cur=null;
function release(delay){clearTimeout(tm);var c=cur;cur=null;if(c){tm=setTimeout(function(){c.classList.remove('is-t2')},delay);}}
document.addEventListener('touchstart',function(e){
 var t=e.target;if(!t.closest)return;
 var card=t.closest('.sm-card');
 if(cur&&cur!==card){clearTimeout(tm);cur.classList.remove('is-t2');cur=null;}
 if(!card)return;
 prep(card);
 if(t.closest('.sm-sw'))return;
 clearTimeout(tm);
 cur=card;card.classList.add('is-t2');
},{passive:true});
document.addEventListener('touchend',function(){release(450)},{passive:true});
document.addEventListener('touchcancel',function(){release(450)},{passive:true});
document.addEventListener('click',function(e){
 var sw=e.target.closest&&e.target.closest('.sm-sw i[data-img]');
 if(!sw)return;
 e.preventDefault();e.stopPropagation();
 var card=sw.closest('.sm-card');if(!card)return;
 var m=main(card);if(!m)return;
 m.removeAttribute('srcset');m.removeAttribute('sizes');
 m.setAttribute('src',sw.getAttribute('data-img'));
 card.classList.add('is-sw');
 card.querySelectorAll('.sm-sw i.is-on').forEach(function(x){x.classList.remove('is-on');});
 sw.classList.add('is-on');
},true);
})();
